import { useEffect } from 'react'

import { Button } from 'antd-mobile'
import { useSWRConfig } from 'swr'

import { useGuideContext } from 'react-provider'
import Icon from '@/components/Icon'
import { useCustomNavigate, useCompletePWATask } from '@/hooks'
import DiscoverGroup from './components/DiscoverGroup'

import DiscoverBookList from './components/DiscoverBookList'
import DiscoverComment from './components/DiscoverComment'
import DiscoverDynamic from './components/DiscoverDynamic'
import DiscoverSwiper from './components/DiscoverSwiper'
import HomeLayout from '@/components/HomeLayout'

const Discover = () => {
  const { cache } = useSWRConfig()
  useCompletePWATask()
  const { customNavigator } = useCustomNavigate()

  const { startWhenReady, reportReady } = useGuideContext()

  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 0)
    }, 200)

    // 删除threadList的所有swr key
    const threadListKeys = Array.from(cache.keys()).filter((key) => key.includes(`/cmtyApi/post/list`))
    threadListKeys.forEach((key) => {
      cache.delete(key)
    })

    // 删除bookList的所有swr key
    const bookListKeys = Array.from(cache.keys()).filter((key) => key.includes(`/cmtyApi/storyList/list`))
    bookListKeys.forEach((key) => {
      cache.delete(key)
    })

    requestAnimationFrame(() => {
      // 用户引导启动函数
      startWhenReady(
        [
          {
            element: () => {
              return document.querySelector(`.guide-bookListBox`)!
            },
            popover: {
              title: 'Booklist',
              description: 'Discover what others are reading.',
            },
            key: 'bookListBox',
          },
          {
            element: () => {
              return document.querySelector(`.guide-commentBox`)!
            },
            popover: {
              title: 'BookReview',
              description: 'See what others are reading and thinking.',
            },
            key: 'commentBox',
          },
          {
            element: () => {
              return document.querySelector(`.guide-groupBox`)!
            },
            popover: {
              title: 'Group',
              description: 'Explore what others are discussing.',
            },
            key: 'groupBox',
          },
          {
            element: () => {
              return document.querySelector(`.guide-dynamicBox`)!
            },
            popover: {
              title: 'Thread',
              description: 'See what others are talking about.',
            },
            key: 'dynamicBox',
          },
          {
            element: () => {
              return document.querySelector(`.guide-publishBtn`)!
            },
            popover: {
              title: 'Post',
              description: 'Share your thoughts or create a booklist.',
            },
            key: 'publishBtn',
          },
        ],
        4, // 需要等待上报的组件数
      )
    })

    return () => clearTimeout(timer) // 清理定时器
  }, [])

  return (
    <HomeLayout>
      <div className='pb-[89px] pt-[101px] md:px-[37px] lg:px-0' id='discover'>
        <DiscoverSwiper className={`guide-swiperBox mx-[30px] mb-[37px] mt-[43px] md:mx-0`} />
        <DiscoverBookList className={`guide-bookListBox mb-[90px] mt-[37px]`} />
        <DiscoverComment className={`guide-commentBox mb-[90px]`} />
        <DiscoverGroup className={`guide-groupBox mb-[90px]`} />
        <DiscoverDynamic className={`guide-dynamicBox mb-[47px]`} />
        <Button
          className='guide-publishBtn g-btn-v2 fixed bottom-[164px] right-[45px] h-[112px] w-[112px] rounded-full'
          onClick={() => {
            customNavigator('/publish')
          }}
          ref={() => {
            reportReady('publishBtn')
          }}
        >
          <Icon name='Add' />
        </Button>
      </div>
    </HomeLayout>
  )
}

export default Discover
